import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import {
  LoginEmailContainer,
  ForgotPasswordContainer,
  ResetPasswordContainer
} from 'containers';

import { LoginServices } from 'components';

const Login = () => (
  <Switch>
    <Route path={'/login-email'} component={LoginEmailContainer} />
    <Route path={'/forgot-password'} component={ForgotPasswordContainer} />
    <Route path={'/reset-password'} component={ResetPasswordContainer} />
    <Route path={'/'} component={LoginServices} />
    <Route render={() => <Redirect to={'/'} />} />
  </Switch>
);

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js